import type {SkillRef} from '../types';

export const FIXTURE_SKILLS: SkillRef[] = [
  {id: 'skill-div-2d', name: 'Divide two-digit numbers by one-digit numbers', code: '5NB6'},
  {id: 'skill-frac-div', name: 'Divide fractions by fractions', code: '6NS1'},
  {id: 'skill-area-tri', name: 'Find the area of triangles', code: '6G01'},
  {id: 'skill-percent', name: 'Solve single-step percent problems', code: '6RP3'},
  {id: 'skill-gcf', name: 'Find the greatest common factor of whole numbers', code: '6NS4'},
  {id: 'skill-mult-2d', name: 'Multiply two-digit numbers by one-digit numbers', code: '4NB5'},
  {id: 'skill-frac-mult', name: 'Multiply fractions', code: '5NF4'},
  {id: 'skill-area-rect', name: 'Find the area of rectangles', code: '3MD7'},
  {id: 'skill-div-3d', name: 'Divide three-digit numbers by two-digit numbers', code: '6NS2'},
  {id: 'skill-ratio', name: 'Decide if two quantities are proportional', code: '7RP2'}
];

/** What every diagnostic tests. The other skills arrive only through the edges below. */
export const TESTED_SKILL_IDS = [
  'skill-div-2d',
  'skill-frac-div',
  'skill-area-tri',
  'skill-percent',
  'skill-gcf'
];

/** builds_toward, read backward: skill id → its prerequisite. */
export const BUILDS_TOWARD: Record<string, string> = {
  'skill-div-2d': 'skill-mult-2d',
  'skill-frac-div': 'skill-frac-mult',
  'skill-area-tri': 'skill-area-rect'
};

/** builds_toward, read forward: skill id → the next skill up. */
export const BUILDS_ON: Record<string, string> = {
  'skill-div-2d': 'skill-div-3d',
  'skill-frac-div': 'skill-ratio',
  'skill-percent': 'skill-ratio'
};

/** relates_to: skill id → a skill that shares its concept. */
export const RELATES_TO: Record<string, string> = {
  'skill-gcf': 'skill-mult-2d',
  'skill-percent': 'skill-frac-mult',
  'skill-frac-div': 'skill-div-3d'
};
